import React, { FC } from 'react';
import { Layout } from 'antd';
import { BasicProps as ContentProps } from 'antd/lib/layout/layout';

const { Content } = Layout;

export const LayoutContent: FC<ContentProps> = React.memo((props) => {
  return <Content id='mainContent' {...props} />;
});
